<template>
  <div v-if="!hiddenItem(item)" class="menu-wrapper">
    <template v-if="hideSubMenu">
      <app-link :to="basePath">
        <el-menu-item :index="basePath">
          <i class="iconfont side-icon" :class="item.meta && item.meta.icon"></i>
          <span slot="title" :style="{ color: getColor(item) }">{{ item.menuName }}</span>
        </el-menu-item>
      </app-link>
    </template>
    <el-submenu v-else ref="subMenu" :index="resolvePath(item.path)" popper-append-to-body>
      <template slot="title">
        <i class="iconfont side-icon" :class="item.meta && item.meta.icon" :title="item.menuName"></i>
        <span slot="title">{{ item.menuName }}</span>
      </template>

      <sidebar-item v-for="(child, index) in item.children" :key="child.path + index" :item="child"
        :base-path="resolvePath(child.path)" class="nest-menu" :is-nest="true" />
    </el-submenu>
  </div>
</template>

<script>
import path from 'path'
import AppLink from './Link'

export default {
  name: 'SidebarItem',
  components: { AppLink },
  props: {
    // route object
    item: {
      type: Object,
      required: true
    },
    basePath: {
      type: String,
      default: ''
    }
  },
  mounted() { },
  data() {
    this.onlyOneChild = null
    return {}
  },
  computed: {
    hideSubMenu() {
      return this.showSubLength === 0 || (this.showSubLength === 1 && this.item.extendHidden)
    },
    showSubLength() {
      let children = this.item.children || []
      const showingChildren = children.filter((item) => {
        return !item.hidden && !item.meta.hidden
      })
      return showingChildren.length
    },
    sidebarOpen() {
      return this.$store.getters.sidebarOpen
    }
  },
  methods: {
    getColor(item) {
      if (this.basePath == '/order/orderCreate' && this.$route.path == '/order/orderCreate/create') {
        return 'rgb(64, 158, 250)'
      }
    },
    hiddenItem(item) {
      return item.hidden || (item.meta && item.meta.hidden)
    },
    linkTo: function () {
      if (this.$router.currentRoute && this.$router.currentRoute.path !== this.basePath) {
        this.$router.replace({
          path: this.basePath
        })
      }
    },
    resolvePath(routePath) {
      return path.resolve(this.basePath, routePath)
    }
  }
}
</script>
<style scoped>
.nest-menu li {
  background-color: #1f2d3d !important;
}

.side-icon {
  padding-right: 10px;
}

.nest-menu li:hover {
  background-color: #001528 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/Sidebar/SidebarItem.vue